export * from './wait.component';



// WEBPACK FOOTER //
// ./src/app/layout/wait/index.ts